import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function getDynamicStyles(numOfOptions, index, totalColumns) {
  const columnIndex = index % totalColumns;
  const rowIndex = Math.floor(index / totalColumns);
  const hasLeftBorder = columnIndex === 0;
  const hasTopBorder = rowIndex === 0;
  const lastRowIndex = Math.floor((numOfOptions - 1) / totalColumns);
  const isTopLeft = index === 0;
  const isTopRight = rowIndex === 0 && (columnIndex === totalColumns - 1 || index === numOfOptions - 1);
  const isBottomLeft = rowIndex === lastRowIndex && columnIndex === 0;
  const isBottomRight = index === numOfOptions - 1;
  return {
    borderBlockStartWidth: hasTopBorder ? '100' : undefined,
    borderBlockEndWidth: '100',
    borderInlineStartWidth: hasLeftBorder ? '100' : undefined,
    borderInlineEndWidth: '100',
    borderStartStartRadius: isTopLeft ? '100' : undefined,
    borderStartEndRadius: isTopRight ? '100' : undefined,
    borderEndStartRadius: isBottomLeft ? '100' : undefined,
    borderEndEndRadius: isBottomRight ? '100' : undefined
  };
}
function DurationOptionsGridItem({
  index,
  isSelected,
  numOfOptions,
  onClick,
  option
}) {
  const onClickRef = useRef(onClick);
  const ref = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    onClickRef.current = onClick;
  }, [onClick]);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const handleKeyDown = event => {
      if (event.code === 'Enter' || event.code === 'Space') {
        onClickRef.current();
      }
    };
    element.addEventListener('keydown', handleKeyDown);
    return () => {
      element.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const backgroundColor = isSelected ? 'fill-tertiary-pressed' : isHovered ? 'fill-tertiary-hover' : undefined;
  return /*#__PURE__*/_jsx(GridItem, {
    paddingInline: "0",
    size: numOfOptions === 1 ? 12 : 4,
    children: /*#__PURE__*/_jsx(View, Object.assign({
      backgroundColor: backgroundColor,
      borderColor: "border-core-default",
      borderRadius: "0",
      borderStyle: "solid",
      borderWidth: "0",
      cursor: "pointer",
      inlineSize: "100%",
      onClick: onClick,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      ref: ref,
      role: "button",
      tabIndex: 0
    }, getDynamicStyles(numOfOptions, index, 3), {
      children: /*#__PURE__*/_jsx(TruncateString, {
        justifyContent: "center",
        useFlex: true,
        paddingBlock: "100",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(Small, {
          children: option.text
        })
      })
    }))
  });
}
export function DurationOptionsGrid({
  onChange,
  options,
  value
}) {
  const handleOnChange = useCallback(duration => {
    onChange({
      target: {
        value: duration
      }
    });
  }, [onChange]);
  if (!options.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(Grid, {
    alignSelf: "center",
    "aria-labelledby": "meeting-duration",
    id: "duration-select",
    inlineSize: "100%",
    children: options.map((option, index) => {
      return /*#__PURE__*/_jsx(DurationOptionsGridItem, {
        index: index,
        isSelected: option.value === value,
        numOfOptions: options.length,
        onClick: () => handleOnChange(option.value),
        option: option
      }, option.value);
    })
  });
}